<template>
  <div class="content-right">
    <column class="column2" :title="props.title" :ele_have_scrollbar="true" :path="props.path">
      <template #abc>
        <ul>
          <li
            class="my-li hover-change-color"
            v-for="(item, index) in mydata.problemArr"
            :key="index"
            @click="liClick(item.id)"
          >
            <p>{{ item.title }}</p>
          </li>
        </ul>
      </template>
    </column>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import column from "@/components/column/index.vue";
import rowBookCards from "@/components/rowBookCards/index.vue";
// import { examSearchList } from "@/api/boutiqueTaobaoQuestions/listenBig/index.js";
import { useRouter,useRoute } from "vue-router";
// 推荐列表接口
import { getRecommendList } from "@/api/recommend/index.js";

import { dictKeyWord } from "@/utils/dict.js";
const route = useRoute();

const router = useRouter();

const mydata = reactive({
  problemArr: [],
});

const props = defineProps({
  title: {
    type: String,
    default: "必刷好题",
  },
  path: {
    type: String,
    default: "",
  },
  
});


////////////////////////////////////////////
//推荐列表
function getRecommendFn() {
  // 使用标题在字典中进行匹配，得到对应的keyword值
  let keyword = dictKeyWord[props.title];
  getRecommendList({
    keyword: keyword,
    page: 1,
    psize: 10,
    column_key: route.path,
  }).then((res) => {
    mydata.problemArr = res.data.list;
  });
}

getRecommendFn();

////////////////////////////////////////////



// function examSearchListFN() {
//   examSearchList({ is_recommended: 1 }).then((res) => {
//     mydata.problemArr = res.data.list;
//   });
// }

// examSearchListFN();

function liClick(id) {
  router.push({
    path: "/layout/list/topicSubjectDetails",
    query: { id },
  });
}
</script>

<style scoped lang="scss">
// 列表
.my-li {
  > p:nth-of-type(1) {
    width: calc(100% - 0px);
    position: static !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    cursor: pointer;
  }
}

.content-right {
  // border: 1px solid blue;
  width: 320px;
  // 标题
  :deep(.box-column) {
    margin-bottom: 16px;
    .column-title {
      > p {
        display: none;
      }
    }
  }
  // 内容
  .column2 {
    li {
        margin-left: 20px;
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      // margin-bottom: 16px;
      // border:1px solid red;
      
      position: relative;
      line-height: 24px;
      margin-bottom:10px;
      // white-space: nowrap; //不折行
      // text-overflow: ellipsis; //文本溢出 用省略号显示
      // overflow: hidden;
      p {
        font-size: 14px;
        font-weight: 400;
        // color: #888888;
        position: absolute;
        right: 0px;
        top: 0px;
      }
    }
    li:nth-last-of-type(1) {
      margin-bottom: 0px;
    }

    li:hover{
      color:#009DE0;
    }
  }
  // 穿透
  :deep(.column-content) {
    height: 200px !important;
  }
}
</style>
